import { render, staticRenderFns } from "./BulkExport.vue?vue&type=template&id=2385c46f&scoped=true"
import script from "./BulkExport.vue?vue&type=script&lang=js"
export * from "./BulkExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2385c46f",
  null
  
)

export default component.exports